import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css'; 
// Import all the components
import Navbar from './components/Navbar';
import Home from './components/Home';
import OurStory from './components/OurStory';
import OurServices from './components/OurServices';
import LetsConnect from './components/LetsConnect';
import ZzayraatConnect from './components/ZzayraatConnect';
import ServiceSection from './components/ServiceSection';
import Footer from './components/Footer'; 
import ScrollToTop from './components/ScrollToTop';
import ServiceSection1 from './components/ServiceSection1';
import ServiceSection2 from './components/ServiceSection2';
import ServiceSection3 from './components/ServiceSection3';
import ServiceSection4 from './components/ServiceSection4';
import ServiceSection5 from './components/ServiceSection5';



function App() {
  return (
    <Router>
      <div className="app-container">
      
        <Navbar />
        <ScrollToTop/>
        <main className="app-main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/our-services" element={<OurServices />} />
            <Route path="/lets-connect" element={<LetsConnect />} />
            <Route path="/s" element={<ServiceSection />} />
            <Route path="/branding" element={<ServiceSection1 />} />
            <Route path="/technology" element={<ServiceSection2 />} />
            <Route path="/media-production" element={<ServiceSection3 />} />
            <Route path="/pr-management" element={<ServiceSection4 />} />
            <Route path="/digital-stratergy" element={<ServiceSection5 />} />
            <Route path="/zzayraat-connect" element={<ZzayraatConnect />} />
          </Routes>
        </main>
        <Footer />        
      </div>
    </Router>
  );
}

export default App;